import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import lodash from "lodash";

const Actions = ({ edit, loading, onToggle, onDelete, onSave }) =>
  edit
    ? [
        <button
          key="save"
          className="btn btn-text"
          disabled={loading}
          onClick={onSave}
        >
          SAVE
        </button>,
        <button
          key="cancel"
          className="btn btn-text"
          disabled={loading}
          onClick={onToggle}
        >
          CANCEL
        </button>,
      ]
    : [
        <button key="edit" className="btn btn-text" onClick={onToggle}>
          EDIT
        </button>,
        <button key="delete" className="btn btn-text" onClick={onDelete}>
          REMOVE
        </button>,
      ];

const HourlyRate = ({ state, edit, loading, onChange }) =>
  edit ? (
    <div>
      <div className="form-group">
        <div className="input-group">
          <span className="input-group-addon">$</span>
          <input
            placeholder="10.50"
            className="form-control employee-position-hourly-rate"
            type="number"
            step="0.01"
            min="0"
            max="999.99"
            disabled={loading}
            value={state}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  ) : (
    <div>
      {Math.round(state) == 0
        ? "None"
        : parseFloat(Math.round(state * 1000) / 1000).toFixed(2)}
    </div>
  );

const Code = ({ state, defaultState, edit, loading, onChange }) =>
  edit ? (
    <input
      title="Code"
      className="form-control"
      disabled={loading}
      value={state || defaultState || ""}
      onChange={onChange}
    />
  ) : (
    <div>{state}</div>
  );

const PositionName = ({
  positions,
  name,
  positionId,
  edit,
  loading,
  onChange,
}) =>
  edit ? (
    <select
      className="form-control"
      title="Select Position"
      disabled={loading}
      value={positionId || ""}
      onChange={onChange}
    >
      <option value="" disabled>
        Select Position
      </option>

      {positions.map((position) => (
        <option key={position.id} value={position.id}>
          {position.name}
        </option>
      ))}
    </select>
  ) : (
    name
  );

class Position extends React.Component {
  state = {
    edit: this.props.edit,
    loading: false,
    positionId: this.props.data.positionId,
    hourlyRate: this.props.data.hourlyRate,
    code: this.props.data.code,
    priority: this.props.data.priority,
  };

  render() {
    const { provided, snapshot, data, allPositions, addedIds } = this.props;
    const { edit, loading } = this.state;
    const positions = allPositions.filter(
      (position) => !addedIds.includes(position.id)
    );

    return (
      <tr
        ref={provided.innerRef}
        className={classNames("draggable-row", {
          "is-dragging": snapshot.isDragging,
        })}
        {...provided.draggableProps}
      >
        <td style={{ width: 30 }} {...provided.dragHandleProps}>
          {!edit && <h4 className="light-grey-text">☰</h4>}
        </td>
        <td style={{ width: 770 }}>
          <PositionName
            positions={positions}
            name={data.name}
            positionId={this.state.positionId}
            edit={edit}
            loading={loading}
            onChange={this.handlerChangePosition}
          />
        </td>
        <td style={{ width: 120 }}>
          <Code
            state={this.state.code}
            defaultState={this.props.data.defaultCode}
            edit={edit}
            loading={loading}
            onChange={this.handlerChangeCode}
          />
        </td>
        <td style={{ width: 150 }}>
          <HourlyRate
            state={this.state.hourlyRate}
            edit={edit}
            loading={loading}
            onChange={this.handlerChangeHourlyRate}
          />
        </td>
        <td
          style={{ width: 200, paddingTop: edit ? 0 : 15 }}
          className="text-right"
        >
          <Actions
            edit={edit}
            loading={loading}
            onToggle={this.handlerToggle}
            onDelete={this.handlerDelete}
            onSave={this.handlerSave}
          />
        </td>
      </tr>
    );
  }

  handlerResetState = () => {
    this.setState({
      positionId: this.props.data.positionId,
      hourlyRate: this.props.data.hourlyRate,
      code: this.props.data.code,
      priority: this.props.data.priority,
    });
  };

  handlerChangePosition = (e) => {
    const positionId = parseInt(e.target.value);
    const position = lodash.find(this.props.allPositions, { id: positionId });
    const hourlyRate =
      position && position.default_hourly_rate
        ? position.default_hourly_rate
        : this.props.data.hourlyRate;

    const code =
      position && position.default_code
        ? position.default_code
        : this.props.data.code;

    this.setState({ positionId, hourlyRate, code });
  };

  handlerChangeHourlyRate = (e) =>
    this.setState({ hourlyRate: e.target.value });
  handlerChangeCode = (e) => this.setState({ code: e.target.value });

  handlerToggle = () => {
    if (this.props.data.id) {
      this.setState({ edit: !this.state.edit }, this.handlerResetState);
    } else {
      this.props.onRemove(this.props.data._id);
    }
  };

  handlerDelete = () => {
    this.props.onDelete(this.props.data.id);
  };

  handlerSave = () => {
    this.setState({ loading: true });

    const data = {
      priority: this.state.priority,
      position_id: this.state.positionId,
      hourly_rate: this.state.hourlyRate,
      code: this.state.code,
    };

    if (this.props.data._id) {
      data._id = this.props.data._id;
    }

    this.props.onSave(this.props.data.id, data, (status) => {
      if (!this.props.data.id && status) {
        return;
      }

      this.setState({ loading: false }, () => {
        if (status) {
          this.handlerToggle();
        }
      });
    });
  };
}

Position.defaultProps = {
  provided: PropTypes.object,
  snapshot: PropTypes.object,
  data: PropTypes.object.isRequired,
  allPositions: PropTypes.array,
  addedIds: PropTypes.array,
  onDelete: PropTypes.func,
  onSave: PropTypes.func,
  onRemove: PropTypes.func,
};

export default Position;
